
import Vue from 'vue'
import axios from 'axios'
import { mapState } from 'vuex'
import { API_HOST } from "../../config/app-const";

export default {
  created () {
    axios.defaults.baseURL = API_HOST
    axios.defaults.headers = {
      Authorization: `Token token=${this.accessToken}`
    };
    Object.defineProperty(Vue.prototype, '$axios', { value: axios });
  },
  
  computed: {
    ...mapState({
      user: state => state.user.user.data,
    }),
    accessToken() { return this.user ? this.user.accessToken : null },
  },
  methods: {

    apiCall(route, method = 'get', body = {}) {
      return new Promise((resolve, reject) => {
        this.$axios[method](route, body)
          .then(({ data }) => resolve(data))
          .catch((e) => reject(e));
      })
    }
  },
}
